export const EVENT_CONTEXT = 'events';
export const ATHLETE_CONTEXT = 'athletes';
export const RESULT_CONTEXT = 'unclaimed';
